import Box from "@jewlr/storybook/core/box"
import loadable from "@loadable/component"
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"

import IntersectionWrapper from "components/common/intersection-wrapper"
import { retry, IS_JEWLR } from "helpers/application"

import ProductRecommendations from "./product-recommendations"
import RecentlyViewed from "./recently-viewed"

const ProductGallery = loadable(() =>
  retry(() => import("areas/product/jewlr/product-gallery"))
)
const Reviews = loadable(() => retry(() => import("areas/product/reviews")))
const AsSeenIn = loadable(() =>
  retry(() => import("areas/landing/elements/landing-as-seen-in"))
)
const CocoonNecklace = loadable(() =>
  retry(() => import("./info/cocoon-necklace"))
)
const DeliverValue = loadable(() => retry(() => import("./info/deliver-value")))
const EthicallySourced = loadable(() =>
  retry(() => import("./info/ethically-sourced"))
)
const Packaging = loadable(() => retry(() => import("./info/packaging")))
const Perks = loadable(() => retry(() => import("./info/perks")))
const ProductDescription = loadable(() =>
  retry(() => import("./info/product-description"))
)
const QualityWatches = loadable(() =>
  retry(() => import("./info/quality-watches"))
)
const QrCodeNecklace = loadable(() =>
  retry(() => import("./info/qrcode-necklace"))
)
const WildlifeFoundation = loadable(() =>
  retry(() => import("./info/wildlife-foundation"))
)
const CustomerReviews = loadable(() =>
  retry(() => import("./info/customer-reviews"))
)

const InternalProductFooter = ({
  hasDiamondSelector,
  hasFreeResizing,
  hasYotpoGallery,
  hidePackaging,
  isAccessory,
  is_watches,
  styleCode,
}) => {
  return (
    <Box bg={{ _: "grey.4", tablet: "white" }} mb={IS_JEWLR() ? 0 : 8}>
      <Box
        bg="white"
        borderTop={{ tablet: "1px solid #d9d9d9" }}
        contain
        maxWidth={{ desktop: "1440px" }}
        px={{ tablet: 0 }}
      >
        <ProductDescription />
      </Box>
      {IS_JEWLR() && (
        <>
          <Box bg="white">
            {styleCode === "JWLP0578" && (
              <IntersectionWrapper>
                <Box contain>
                  <WildlifeFoundation />
                </Box>
              </IntersectionWrapper>
            )}
            {styleCode === "JWLN0593" && (
              <IntersectionWrapper>
                <Box contain>
                  <QrCodeNecklace />
                </Box>
              </IntersectionWrapper>
            )}
            {styleCode === "JWLP0614" && (
              <IntersectionWrapper>
                <Box contain>
                  <CocoonNecklace />
                </Box>
              </IntersectionWrapper>
            )}
            {!isAccessory && (
              <IntersectionWrapper>
                <Box
                  contain
                  maxWidth={{ desktop: "1440px" }}
                  px={{ tablet: 0 }}
                >
                  <ProductRecommendations />
                </Box>
              </IntersectionWrapper>
            )}
            {!isAccessory && sl.config.use_yotpo && hasYotpoGallery && (
              <IntersectionWrapper>
                <Box contain>
                  <ProductGallery styleCode={styleCode} />
                </Box>
              </IntersectionWrapper>
            )}
            {is_watches && (
              <IntersectionWrapper>
                <QualityWatches />
              </IntersectionWrapper>
            )}
            <IntersectionWrapper>
              <Perks
                hasDiamondSelector={hasDiamondSelector}
                hasFreeResizing={hasFreeResizing}
              />
            </IntersectionWrapper>
            <IntersectionWrapper>
              <AsSeenIn />
            </IntersectionWrapper>
            {!hidePackaging && (
              <IntersectionWrapper>
                <Box contain>
                  <Packaging />
                </Box>
              </IntersectionWrapper>
            )}
          </Box>
          <IntersectionWrapper>
            <Box contain>
              <DeliverValue is_watches={is_watches} />
            </Box>
          </IntersectionWrapper>
          {!is_watches && (
            <IntersectionWrapper>
              <EthicallySourced />
            </IntersectionWrapper>
          )}
          {sl.config.use_yotpo && (
            <Box id="product-reviews">
              <IntersectionWrapper>
                <CustomerReviews />
                <Box bg="grey.4" px={{ _: 2, tablet: 0 }} py={2}>
                  <Box contain textAlign="left">
                    <Reviews {...{ styleCode }} />
                  </Box>
                </Box>
              </IntersectionWrapper>
            </Box>
          )}
          <RecentlyViewed />
        </>
      )}
    </Box>
  )
}

InternalProductFooter.propTypes = {
  hasDiamondSelector: PropTypes.bool,
  hasFreeResizing: PropTypes.bool,
  hasYotpoGallery: PropTypes.bool,
  hidePackaging: PropTypes.bool,
  isAccessory: PropTypes.bool,
  is_watches: PropTypes.bool,
  productType: PropTypes.string,
  styleCode: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    hasDiamondSelector: state.wizard.hasDiamondSelector,
    hasFreeResizing: state.wizard.description.product_resizable,
    hasYotpoGallery: state.wizard.hasYotpoGallery,
    hidePackaging: state.wizard.hidePackaging,
    isAccessory: state.wizard.description.product_type === "ACCESSORY",
    is_watches: state.wizard.description.is_watches,
    productType: state.wizard.description.product_type,
    styleCode: state.choices.style_code && state.choices.style_code.value,
  }
}

const ProductFooter = connect(mapStateToProps)(InternalProductFooter)

export default ProductFooter
